import { Controller } from "@hotwired/stimulus"

// Civic Warmth replacement for Bootstrap's data-bs-dismiss: removes the
// controller element (flash alerts, banners).
//
//   <div class="alert alert-info" data-controller="dismiss">
//     ...
//     <button data-action="dismiss#remove" aria-label="Close">×</button>
//   </div>
export default class extends Controller {
  remove() {
    this.element.remove()
  }
}
